import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { DepartmentModel } from 'src/app/models/management/department.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { DepartmentTableModel } from 'src/app/models/tables/management/department-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  constructor(private _httpClient: HttpClient) { }
  createDepartment(departmentModel: DepartmentModel): Observable<DepartmentModel> {
    return this._httpClient.post<DepartmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.CreateDepartment}`,
      departmentModel);
  }

  deleteDepartment(departmentId: number): Observable<DepartmentModel> {
    return this._httpClient.delete<DepartmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.DeleteDepartment}/${departmentId}`);
  }

  getAllDepartment(): Observable<Array<DepartmentModel>> {
    return this._httpClient.get<Array<DepartmentModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.GetAllDepartment}`);
  }

  getAllDepartmentsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<DepartmentTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<DepartmentTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.GetAllDepartmentsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.GetColumnsForConsultationAsync}`);
  }

  getDepartmentById(departmentId: number): Observable<DepartmentModel> {
    return this._httpClient.get<DepartmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.GetDepartmentById}/${departmentId}`);
  }

  getDepartmentByKeys(countryId: number, code: string): Observable<DepartmentModel> {
    const params = new HttpParams()
      .set('countryId', countryId)
      .set('code', code || '')
    return this._httpClient.get<DepartmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.GetDepartmentByKeys}`, { params: params });
  }

  updateDepartment(departmentModel: DepartmentModel): Observable<DepartmentModel> {
    return this._httpClient.put<DepartmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.UpdateDepartment}`,
      departmentModel);
  }

  getAllDepartmentsForSelect(): Observable<CustomListDropdown[]> {
    return this._httpClient.get<CustomListDropdown[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.GetAllDepartmentsForSelectAsync}`,);
  }

  getAllDepartmentsByCountryIdForSelect(countryId: number): Observable<CustomListDropdown[]> {
    const params = new HttpParams().set('countryId', countryId)
    return this._httpClient.get<CustomListDropdown[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.department.GetAllDepartmentsByCountryIdForSelectAsync}`,
      { params: params }
    );
  }
}
